<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :onFetchData="onFetchData"
    :form="form"
    title="小程序其他配置"
    resource="app_configs"
    :onFormSubmit="handleSubmit"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AppConfig extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  async onFetchData() {
    if (this.type === 'edit' || this.type === 'show') {
      const data = await this.$request.get('/app_config');
      return {  data }
    }
  }

  async handleSubmit({ data }) {
    try {
      this.formLoading = true;
      let body = data;
      await this.$request.put('/app_config', body);
      this.$message.success('更新成功');
      this.$router.push({ name: 'app_configs.show' });
    } finally {
      this.formLoading = false;
    }
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      {
        prop: 'ext_json.navigateToMiniProgramAppIdList',
        label: '可跳转小程序appId',
        width: 150
      },
      {
        prop: 'updated_at',
        label: '更新时间',
        renderCell: 'time',
        sortable: true,
        minWidth: 120
      }
    ].filter(Boolean);
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      {
        renderCell: () => {
          return (
            <el-alert
              title="配置更新后不会马上生效，需要自行提交审核，待审核通过后发布了才会生效"
              type="warning"
            >
            </el-alert>
          )
        }
      },
      {
        prop: 'ext_json.navigateToMiniProgramAppIdList',
        label: '可跳转小程序appId',
        renderCell: {
          component: 'textarea',
          hint: '多个 appid 请用;分隔。',
        }
      }
    ];
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: '编辑',
          to: { name: 'app_configs.edit', params: { id: row.id } }
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/app_config',
    name: 'app_configs.show',
    component: AppConfig,
    props: {
      type: 'show'
    },
    meta: {
      backBtn: false
    }
  },
  {
    path: '/app_config/edit',
    name: 'app_configs.edit',
    component: AppConfig,
    props: {
      type: 'edit'
    }
  }
]
</script>
